export const episodes_controls_open = (state = false, action) => {
  switch (action.type) {
    case 'EPISODES_CONTROLS_SET_OPEN':
      return true;
    case 'EPISODES_CONTROLS_SET_CLOSED':
      return false;
    case 'EPISODES_CONTROLS_TOGGLE':
      return !state;
    default:
      return state;
  }
};

export const small_spinner_hidden = (state = false, action) => {
  switch (action.type) {
    case 'SHOW_SMALL_SPINNER':
      return false;
    case 'HIDE_SMALL_SPINNER':
      return true;
    default:
      return state;
  }
};

export const current_episode_comments = (state = [], action) => {
  let idx = state.indexOf(state.filter(c => c.id == action.commented_id && c.comment_type == action.commented_type)[0]);
  switch (action.type) {
    case 'ADD_NEW_COMMENT_TO_COMMENT_LIST':
      return [{...action.payload, ...{comment_type: 'Comment', replies: [], disliked: false, owned: true, pop_comment_replies_count: 0} }, ...state];
    case 'SET_CURRENT_EPISODE_COMMENTS':
      return action.current_episode_comments;
    case 'APPEND_CURRENT_EPISODE_COMMENTS':
      return [
        ...state,
        ...action.comments_to_load
      ];
    case 'PREPPEND_CURRENT_EPISODE_COMMENTS_WITH_NEW_POPPIN':
      return [
        {
          ...action.payload,
          comment_type: 'TsukkomiComment',
          disliked: false,
          liked: false,
          pop_comment_replies_count: 0,
          replies: []
        },
        ...state
      ];
    case 'CUT_REPLIES_FOR':
      return [
        ...state.slice(0,idx),
        Object.assign({}, state[idx], {
          replies: state[idx].replies.slice(
            state[idx].replies.length-2,
            state[idx].replies.length
          )
        }),
        ...state.slice(idx+1, state.length)
      ];
    case 'SET_REPLIES_FOR':
      let replies_count = action.replies.length;
      return [
        ...state.slice(0,idx),
        Object.assign({}, state[idx], {
          pop_comment_replies_count: replies_count,
          replies: (action.cutted ? action.replies.slice(replies_count-2, replies_count) : action.replies)
        }),
        ...state.slice(idx+1, state.length)
      ];
    case 'ADD_REPLY_FOR':
      return [
        ...state.slice(0,idx),
        Object.assign({}, state[idx], {
          pop_comment_replies_count: state[idx].pop_comment_replies_count + 1,
          replies: state[idx].replies.concat([action.reply])
        }),
        ...state.slice(idx+1, state.length)
      ];
    case 'SET_REACTION_FOR':
      let reaction_socials = {
        liked: action.reaction.like,
        disliked: action.reaction.dislike,
        likes_count: action.reaction.parent.likes_count,
        dislikes_count: action.reaction.parent.dislikes_count
      };

      if (action.commented_id == action.reaction.parent_id && action.commented_type == action.reaction.parent_type) {
        return [
          ...state.slice(0,idx),
          Object.assign({}, state[idx], reaction_socials),
          ...state.slice(idx+1, state.length)
        ];
      } else {
        let rIdx = state[idx].replies.indexOf(state[idx].replies.filter(r => r.id == action.reaction.parent_id && r.commented_type == action.commented_type)[0]);
        return [
          ...state.slice(0,idx),
          Object.assign({}, state[idx], {
            replies: [
              ...state[idx].replies.slice(0, rIdx),
              Object.assign({}, state[idx].replies[rIdx], reaction_socials),
              ...state[idx].replies.slice(rIdx+1, state[idx].replies.length)
            ]
          }),
          ...state.slice(idx+1, state.length)
        ];
      }
    case 'REMOVE_POP_COMMENT':
      let rem_idx = state.indexOf(state.filter(c => c.id == action.optionsMenu.commentedId && c.comment_type == action.optionsMenu.commentedType)[0]);
      return [
        ...state.slice(0, rem_idx),
        ...state.slice(rem_idx+1, rem_idx.length)
      ];
    case 'UPDATE_POP_COMMENT_OR_REPLY':
      let upd_idx = state.indexOf(state.filter(c => c.id == action.commented_id && c.comment_type == action.commented_type)[0]);
      if (action.commented_id == action.parent_id && action.commented_type == action.parent_type) {
        return [
          ...state.slice(0, upd_idx),
          Object.assign({}, state[upd_idx], {body: action.body}),
          ...state.slice(upd_idx+1, upd_idx.length)
        ]
      } else {
        let updReIdx = state[upd_idx].replies.indexOf(state[upd_idx].replies.filter(r => r.id == action.parent_id && r.commented_type == action.commented_type)[0]);
        return [
          ...state.slice(0,upd_idx),
          Object.assign({}, state[upd_idx], {
            replies: [
              ...state[upd_idx].replies.slice(0, updReIdx),
              Object.assign({}, state[upd_idx].replies[updReIdx], {body: action.body}),
              ...state[upd_idx].replies.slice(updReIdx+1, state[upd_idx].replies.length)
            ]
          }),
          ...state.slice(upd_idx+1, state.length)
        ]
      }
    default:
      return state;
  }
};

export const reply_form = (
  state = {
    parent_id: null,
    parent_type: '',
    body: ''
  },
  action
) => {
  switch (action.type) {
    case 'OPEN_REPLY_FORM':
      return {
        parent_id: action.parent_id,
        parent_type: action.parent_type,
        body: ''
      };
    case 'CLOSE_REPLY_FORM':
      return {
        parent_id: null,
        parent_type: '',
        body: ''
      };
    case 'SET_REPLY_FORM_BODY':
      return Object.assign({}, state, {body: action.body});
    default:
      return state;
  }
};

export const update_form = (
  state = {
    parent_id: null,
    parent_type: '',
    commented_id: null,
    commented_type: '',
    body: '',
    endpoint: ''
  },
  action
) => {
  switch (action.type) {
    case 'OPEN_UPDATE_FORM':
      return {
        parent_id: action.parentId,
        parent_type: action.parentType,
        commented_id: action.commentedId,
        commented_type: action.commentedType,
        body: action.body,
        endpoint: action.endpoint
      };
    case 'CLOSE_UPDATE_FORM':
      return {
        parent_id: null,
        parent_type: '',
        commented_id: null,
        commented_type: '',
        body: '',
        endpoint: ''
      };
    case 'SET_UPDATE_FORM_BODY':
      return Object.assign({}, state, {body: action.body});
    default:
      return state;
  }
};

export const update_processing_flag = (state = false, action) => {
  switch (action.type) {
    case 'PROCESSING_ON':
      return true;
    case 'PROCESSING_OFF':
      return false;
    default:
      return state;
  }
}
